<script setup lang="ts">
import { useSnackbar } from "@/utils/useSnackbar"
import { KSnackbar } from "@kaleidoscope-solutions/ks-design-system"

const { hasSnacks, snacks } = useSnackbar()
</script>

<template>
  <div
    v-if="hasSnacks"
    class="pointer-events-none fixed inset-0 z-50 flex flex-col items-center space-y-4 p-4"
    data-test="alert-container"
  >
    <TransitionGroup
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-for="a in snacks"
        :key="a.message"
      >
        <KSnackbar
          :message="a.message"
          :type="a.type"
        />
      </div>
    </TransitionGroup>
  </div>
</template>
